import { Component, Host, Prop, h } from '@stencil/core';
import { storeReviewQuery } from '@ugc-graphql';
import { getVisitorId } from '@ugc-utils/fingerprint';
import { initDomains } from '@ugc-utils/domains';
import { PageType } from './type';
@Component({
  tag: 'ugc-store-review',
  shadow: false,
})
export class UgcStoreReview {
  @Prop({ reflect: true }) pageType: PageType;

  async componentWillLoad() {
    initDomains();
    await getVisitorId();
  }

  getPageView = () => {
    switch (this.pageType) {
      case PageType.AboutUs:
        return <ugc-about-us />;
      case PageType.Shipping:
        return <ugc-shipping />;
      default:
        return null;
    }
  };
  render() {
    return (
      <Host>
        <ugc-apollo query={storeReviewQuery} storeName="storeReviewStaticLanguage">
          {this.getPageView()}
        </ugc-apollo>
      </Host>
    );
  }
}
